import checkboxEmpty from '../../../../assets/svg/check-box-empty.svg';
import checkboxError from '../../../../assets/svg/check-box-error.svg';
import checkboxFilled from '../../../../assets/svg/check-box-filled.svg';
import checkMark from '../../../../assets/svg/check-mark.svg';
import radioChecked from '../../../../assets/svg/radio-checked.svg';
import radioEmpty from '../../../../assets/svg/radio-empty.svg';
import type { FormStyles } from '../../ThemeTypes';
import colors from '../colors';
import fonts from '../fonts';

const forms: FormStyles = {
  formLabel: {
    fontSize: '14px',
    fontWeight: fonts.fontWeights.semibold,
    marginBottom: '2px',
    color: colors.dark,
    '${min.sm}': {
      fontSize: '16px',
    },
  },
  formControl: {
    border: `1px solid ${colors.light}`,
    fontSize: '14px',
    '${min.sm}': {
      fontSize: '16px',
    },
    '&:disabled': {
      cursor: 'not-allowed',
    },
    '&.error': {
      borderColor: colors.error,
    },
    '&.is-valid': {
      borderColor: colors.success,
      backgroundImage: checkMark,
    },
    radio: {
      checked: { backgroundImage: radioChecked },
      unchecked: { backgroundImage: radioEmpty },
    },
    checkbox: {
      checked: { backgroundImage: checkboxFilled },
      unchecked: { backgroundImage: checkboxEmpty },
      error: { backgroundImage: checkboxError },
    },
  },
  selectFormControl: {
    backgroundPosition: 'center right calc(1em + 0.1875rem) !important',
    textOverflow: 'ellipsis',
    wordWrap: 'normal',
  },
  tabButton: {
    borderRadius: '23px',
    selectedBorderWidth: '1px',
  },
};

export default forms;
